import { FeeStatus } from '@40seas/entities/fees';
import { EnumColor } from '@40seas/frontend/common/providers';

export const feeEntityStatusColorMapping = {
    [FeeStatus.Done]: 'success',
    [FeeStatus.Pending]: 'default',
    [FeeStatus.Ready]: 'info',
    [FeeStatus.InProgress]: 'info',
    [FeeStatus.Failed]: 'error',
    [FeeStatus.Canceled]: 'error',
} as { [key in FeeStatus]: EnumColor };
